<template>
	<div class="studioadd_box">
		<div class="studioadd_boxs">
			<div class="studioadd_head">
				创建名师工作室
			</div>
			<el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
				<el-form-item class="studioadd_li" label="工作室名称:" prop="title">
					<el-input v-model="ruleForm.title" placeholder="请输入"></el-input>
				</el-form-item>
				<!-- <el-form-item class="studioadd_li" label="工作室ID:" prop="studio_id">
					<el-input v-model="ruleForm.studio_id" placeholder="请输入工作室Id"></el-input>
				</el-form-item> -->
				<el-form-item class="studioadd_li" label="工作室口号:" prop="slogan">
					<el-input v-model="ruleForm.slogan" placeholder="输入口号"></el-input>
				</el-form-item>
				<el-form-item class="studioadd_li" label="研究方向:" prop="direction">
					<el-input v-model="ruleForm.direction" placeholder="请输入研究方向"></el-input>
				</el-form-item>
				<el-form-item label="工作室logo">
					<el-upload class="upload-demo" :action="uploadImg" :before-upload="beforeAvatarUpload"
						:data="{uid:$store.state.id}" :on-success="upchang" :show-file-list="false">
						<img class="studio_logo" :src="ruleForm.img" alt="" v-if="ruleForm.img">
						<el-button size="small" type="danger" v-if="ruleForm.img">重新上传</el-button>
						<el-button size="small" type="danger" v-else>点击上传</el-button>
						<div style="display: inline-block;margin-left: 10px;" slot="tip" class="el-upload__tip">
							只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>
				</el-form-item>
				<el-form-item label="负责人:">
					<el-button type="danger" v-for="(item,index) in fzrlist" @click="tjcy(1,item.id)">{{item.name}}<i
							class="el-icon-edit el-icon--right"></i></el-button>
					<el-button type="danger" icon="el-icon-plus" plain @click="tjcy(1,'')">添加负责人</el-button>
				</el-form-item>
				<el-form-item label="工作室成员:">
					<el-button type="danger" v-for="(item,index) in userlist" @click="tjcy(2,item.id)">{{item.name}}<i
							class="el-icon-edit el-icon--right"></i></el-button>
					<el-button type="danger" icon="el-icon-plus" plain @click="tjcy(2,'')">添加成员</el-button>
				</el-form-item>

				<el-form-item label="上传工作室图片:">
					<el-upload class="avatar-uploader" :action="uploadImg" :data="{
					uid:$store.state.id}" :show-file-list="false" :before-upload="beforeAvatarUpload"
						:on-success="handleAvatarSuccess">
						<img v-if="ruleForm.file" :src="ruleForm.file" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item>
				<el-form-item label="工作室标签:">
					<el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false"
						@close="handleClose(tag)">
						{{tag}}
					</el-tag>
					<el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput"
						size="small" @keyup.enter.native="handleInputConfirm" @blur="handleInputConfirm">
					</el-input>
					<el-button v-else class="button-new-tag" size="small" @click="showInput">+ 新标签</el-button>
				</el-form-item>
				<el-form-item label="工作室特色:" prop="ts">
					<el-input type="textarea" v-model="ruleForm.ts" :autosize="{ minRows: 4, maxRows:5}" resize="none"
						maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item label="工作室简介:" prop="content">
					<el-input type="textarea" v-model="ruleForm.content" :autosize="{ minRows: 4, maxRows:5}"
						resize="none" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click="submitForm('ruleForm')">{{names}}</el-button>
				</el-form-item>
			</el-form>
		</div>
		<!-- 添加成员 -->
		<el-dialog title="添加栏目" :visible.sync="dialogFormVisible" width="80%" top="40px">
			<el-form ref="form" :model="form" :rules="rulesl" label-width="80px" >
				<el-form-item class="studiotj" prop="name" label="姓名" :label-width="formLabelWidth">
					<el-input v-model="form.name" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item class="studiotj" prop="title" label="职称" :label-width="formLabelWidth">
					<el-input v-model="form.title" placeholder="请输入职称"></el-input>
				</el-form-item>
				<el-form-item class="studiotj" prop="school" label="目前就职" :label-width="formLabelWidth">
					<el-input v-model="form.school" placeholder="请输入学校"></el-input>
				</el-form-item>
				<el-form-item class="studiotj" prop="company" label="学院" :label-width="formLabelWidth">
					<el-input v-model="form.company" placeholder="请输入学院"></el-input>
				</el-form-item>
				<el-form-item class="studiotj" prop="phone" label="联系方式" :label-width="formLabelWidth">
					<el-input v-model="form.phone" placeholder="请输入联系方式"></el-input>
				</el-form-item>
				<el-form-item class="studiotj" prop="email" label="联系邮箱" :label-width="formLabelWidth">
					<el-input v-model="form.email" placeholder="请输入联系邮箱"></el-input>
				</el-form-item>
				<el-form-item class="studioimg" label="上传头像:" :label-width="formLabelWidth" prop="img">
					<el-upload class="upload-demo" :action="uploadImg" :before-upload="beforeAvatarUpload"
						:on-success="upchang1" :show-file-list="false">
						<img class="studio_logo" :src="form.img" alt="" v-if="form.img">
						<el-button size="small" type="danger" v-if="form.img">重新上传</el-button>
						<el-button size="small" type="danger" v-else>点击上传</el-button>
						<div style="display: inline-block;margin-left: 10px;" slot="tip" class="el-upload__tip">
							只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>
				</el-form-item>
				<el-form-item class="studiotj1" label="联系地址" :label-width="formLabelWidth">
					<el-input v-model="form.address" placeholder="请输入地址"></el-input>
				</el-form-item>
				<el-form-item class="studiotj1" label="荣誉称号" :label-width="formLabelWidth">
					<el-input v-model="form.ch" placeholder="请输入荣誉称号"></el-input>
				</el-form-item>
				<el-form-item class="studiotj1" label="教育经历" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.experience" :autosize="{ minRows:2, maxRows:3}"
						resize="none" maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item class="studiotj1" label="主要任职" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.work" :autosize="{ minRows: 2, maxRows:3}" resize="none"
						maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item class="" label="奖项成果" :label-width="formLabelWidth">
					<el-input type="textarea" v-model="form.prize" :autosize="{ minRows: 2, maxRows:3}" resize="none"
						maxlength="150" show-word-limit></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="danger" @click="onSubmit('form')">保存</el-button>
					<el-button @click="qx">取消</el-button>
				</el-form-item>
			</el-form>
		</el-dialog>
	</div>
</template>

<script>
	import {
		studios
	} from '@/axios'
	export default {
		data() {
			return {
				id: '',
				type: '',
				names: "立即创建",
				uploadImg: '',
				// 负责人列表
				fzrlist: [],
				// 成员列表
				userlist: [],
				options: [],
				dialogFormVisible: false,
				formLabelWidth: '100px',
				// 新建工作室
				ruleForm: {
					uid: sessionStorage.getItem("id"),
					title: '',
					// studio_id:'',
					slogan: '',
					direction: '',
					img: '',
					fzrlist: '',
					userlist: '',
					tags: '',
					file: '',
					ts: '',
					content: '',
					token: sessionStorage.getItem("token")
				},
				// 添加成员
				form: {
					name: '',
					title: '',
					school: '',
					company: '',
					phone: '',
					email: '',
					img: '',
					address: '',
					ch: '',
					experience: '',
					work: '',
					prize: '',
					success: '',
					type: '',
					token: sessionStorage.getItem("token")
				},
				rulesl: {
					name: [{
							required: true,
							message: '请输入名称',
							trigger: 'blur'
						},
						{
							min: 2,
							max: 100,
							message: '长度在 2 到 100 个字符',
							trigger: 'blur'
						}
					],
					img: [{
						required: true,
						message: '请选择头像',
						trigger: 'change'
					}],
					title: [{
						required: true,
						message: '请输入职称',
						trigger: 'blur'
					}],
					school: [{
						required: true,
						message: '请输入学校',
						trigger: 'blur'
					}],
					company: [{
						required: true,
						message: '请输入学院',
						trigger: 'blur'
					}],
					phone: [{
							required: true,
							message: "请输入手机号",
							trigger: "blur"
						},
						// 这个只能验证手机号
						// { pattern:/^0{0,1}(13[0-9]|15[7-9]|153|156|18[7-9])[0-9]{8}$/, message: "请输入合法手机号", trigger: "blur" }
						{
							pattern: /^((0\d{2,3}-\d{7,8})|(1[3584]\d{9}))$/,
							message: "请输入正确手机号/电话号",
							trigger: "blur"
						}
					],
					email: [{
							required: true,
							message: "请输入邮箱",
							trigger: "blur"
						},
						{
							pattern: /^([0-9A-Za-z\-_\.]+)@([0-9a-z]+\.[a-z]{2,3}(\.[a-z]{2})?)$/g,
							message: "请输入正确的邮箱",
							trigger: "blur"
						}
					]

				},
				// form:{
				// 	name:'',
				// 	type:'1',
				// },
				index: 0,
				cid: '',
				file: null,
				fileList: [],
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				startTime: {
					disabledDate: time => {
						if (this.ruleForm.end_time) {
							return time.getTime() > this.ruleForm.end_time || time.getTime() < Date.now() -
								8.64e7
						} else {
							// console.log(time)
							// 不能小于当前日期
							return time.getTime() < Date.now() - 8.64e7 // 加- 8.64e7则表示包当天
						}
					}
				},
				endTime: {
					disabledDate: time => {
						// console.log(this.ruleForm.start_time)
						if (this.ruleForm.start_time) {
							return (
								time.getTime() < this.ruleForm.start_time
							)
						} else {
							return time.getTime() < Date.now() - 8.64e7 // 加- 8.64e7则表示包当天
						}
					}
				},
				rules: {
					title: [{
							required: true,
							message: '请输入工作室名称',
							trigger: 'blur'
						},
						{
							min: 3,
							max: 100,
							message: '长度在 3 到 100 个字符',
							trigger: 'blur'
						}
					],
					studio_id: [{
						required: true,
						message: '请输入工作室ID',
						trigger: 'blur'
					}],
					slogan: [{
						required: true,
						message: '请输入工作口号',
						trigger: 'blur'
					}],
					direction: [{
						required: true,
						message: '请输入研究方向',
						trigger: 'blur'
					}],
					ts: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}],
					content: [{
						required: true,
						message: '请输入',
						trigger: 'blur'
					}]

				}
			};
		},
		created() {
			this.id = this.$route.query.id;
			this.type = this.$route.query.type;
			if (this.id) {
				this.names = '编辑提交';
				this.infos();
			}
		},
		mounted() {
			// this.names = sessionStorage.getItem("username");
			this.uploadImg = sessionStorage.getItem('uploadImg');
		},
		methods: {
			// 详情
			infos() {
				let that = this
				studios.studioinfo({
					wid: that.id,
					token: sessionStorage.getItem("token")
				}).then(res => {
					if (res.code == 200) {
						that.dynamicTags = res.data.tags.split(',');
						that.fzrlist = res.data.fzrlist;
						that.userlist = res.data.userlist;
						that.ruleForm = {
							wid: that.id,
							title: res.data.title,
							studio_id: res.data.studio_id,
							slogan: res.data.slogan,
							direction: res.data.direction,
							img: res.data.img,
							fzrlist: '',
							userlist: '',
							tags: '',
							file: res.data.file,
							ts: res.data.remark,
							content: res.data.content,
							token: sessionStorage.getItem("token")
						}
					}
				})

			},
			// 添加成员
			tjcy(index, id) {
				this.cid = id;
				if (id) {
					this.cyinfo(id)
				} else {
					this.form = {
						name: '',
						title: '',
						school: '',
						company: '',
						phone: '',
						email: '',
						img: '',
						address: '',
						ch: '',
						experience: '',
						work: '',
						prize: '',
						success: '',
						type: index,
						token: sessionStorage.getItem("token")
					}
				}
				this.dialogFormVisible = true;
			},
			// 分类

			xuanze(val) {
				this.ruleForm.region = val;
				console.log(this.ruleForm.region)
			},
			handleClose(tag) {
				this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
			},

			showInput() {
				this.inputVisible = true;
				this.$nextTick(_ => {
					this.$refs.saveTagInput.$refs.input.focus();
				});
			},

			handleInputConfirm() {
				if (this.dynamicTags.length < 4) {
					let inputValue = this.inputValue;
					if (inputValue) {
						this.dynamicTags.push(inputValue);
					}
					this.inputVisible = false;
					this.inputValue = '';
				} else {
					this.$message({
						showClose: true,
						message: '最多4个标签',
						type: 'warning'
					});
				}

			},
			// 成员/负责人详情
			cyinfo(id) {
				let that = this;
				studios.studiocyinfo({
					uid: id,
					token: sessionStorage.getItem("token")
				}).then(res => {
					if (res.code == 200) {
						console.log(res.data)
						that.form = {
							uid: res.data.id,
							name: res.data.name,
							title: res.data.title,
							school: res.data.school,
							company: res.data.company,
							phone: res.data.phone,
							email: res.data.email,
							img: res.data.img,
							address: res.data.address,
							ch: res.data.ch,
							experience: res.data.experience,
							work: res.data.work,
							prize: res.data.prize,
							success: res.data.success,
							type: res.data.type,
							token: sessionStorage.getItem("token")
						}

					}
				})
			},

			// 提交成员/负责人
			onSubmit(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let that = this;
						if (that.cid) {
							studios.studiocyupdata(that.form).then(res => {
								if (res.code == 200) {
									that.$message({
										showClose: true,
										message: '修改成功',
										type: 'success'
									});
									that.dialogFormVisible = false;
								}
							})
						} else {
							studios.studiocy(that.form).then(res => {
								if (res.code == 200) {

									if (that.form.type == 1) {
										that.fzrlist.push(res.data);
										console.log(that.fzrlist)
									} else {
										that.userlist.push(res.data);
										console.log(that.userlist)
									}
									that.$message({
										showClose: true,
										message: '提交成功',
										type: 'success'
									});
									that.dialogFormVisible = false;
								}
							})
						}


					}
				});

			},
			// 提交
			submitForm(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let that = this
						that.ruleForm.tags = that.dynamicTags.join(',');
						// 负责人
						if (that.fzrlist.length > 0) {
							that.ruleForm.fzrlist = that.fzrlist.map(item => {
								return item.id
							}).toString();
						}
						// 成员
						if (that.userlist.length > 0) {
							that.ruleForm.userlist = that.userlist.map(item => {
								return item.id
							}).toString();
						}
						if (that.userlist.length > 0 && that.fzrlist.length > 0) {
							if (that.id) {
								studios.studioupdate(that.ruleForm).then(res => {
									if (res.code == 200) {
										that.$message({
											showClose: true,
											message: '编辑成功',
											type: 'success'
										});
										that.$router.go(-1);
									}
								})
							} else {
								studios.studiosadd(that.ruleForm).then(res => {
									if (res.code == 200) {
										that.$message({
											showClose: true,
											message: '提交成功',
											type: 'success'
										});
										that.$router.go(-1);
									}
								})
							}
						} else {
							this.$message({
								showClose: true,
								message: '请完善负责人或成员',
								type: 'warning'
							});
						}

					} else {

					}
				});
			},
			// 编辑提交
			submitForms(formName) {
				this.$refs[formName].validate((valid) => {
					if (valid) {
						let that = this
						that.ruleForm.tags = that.dynamicTags.join(',')
						studios.studioupdate({
							wid: that.id,
							uid: sessionStorage.getItem("id"),
							title: that.ruleForm.title,
							moduleClass: that.ruleForm.region,
							userlist: '',
							start_time: that.ruleForm.start_time,
							end_time: that.ruleForm.end_time,
							is_long: 0,
							slogan: that.ruleForm.slogan,
							file: that.ruleForm.file,
							img: that.ruleForm.img,
							tags: that.ruleForm.tags,
							token: ''
						}).then(res => {
							if (res.code == 200) {
								that.$message({
									showClose: true,
									message: '编辑成功',
									type: 'success'
								});
							}
						})
					} else {

					}
				});
			},

			// 图片上传成功
			handleAvatarSuccess(res, file) {
				if (this.ruleForm.file) {
					this.filedels(this.ruleForm.file, res, 2)

				} else {
					this.ruleForm.file = res.data.src;
				}

				this.$message({
					showClose: true,
					message: '上传成功',
					type: 'success'
				});
			},
			// 图片上传前
			beforeAvatarUpload(file) {
				// console.log(file);
				const isLt2M = file.size / 1024 / 1024 < 1;
				if (!isLt2M) {
					this.$message.error('上传头像图片大小不能超过 1MB!');
					return isLt2M;
				}
			},
			// 文件删除
			filedels(file, data, id) {
				studios.updates({
					url: file,
					token: sessionStorage.getItem("token")
				}).then(res => {
					if (res.code == 200) {
						if (res.code == 200) {
							if (id == 1) {
								this.ruleForm.img = data.data.src;
							} else if (id == 2) {
								this.ruleForm.file = data.data.src;
							} else {
								this.ruleForm.img = data.data.src;
							}

						} else {
							this.$message({
								showClose: true,
								message: '删除失败',
								type: 'error'
							});
						}

					} else {

					}
				})
			},
			qx() {
				let that = this;
				that.dialogFormVisible = false;
			},
			// 文件上传成功
			upchang(res, file) {
				if (this.ruleForm.img) {
					this.filedels(this.ruleForm.img, res, 1)

				} else {
					this.ruleForm.img = res.data.src;
				}
				console.log(res)
				this.$message({
					showClose: true,
					message: '上传成功',
					type: 'success'
				});
			},
			// 成员头像
			upchang1(res, file) {
				if (this.form.img) {
					this.filedels(this.form.img, res, 3)

				} else {
					this.form.img = res.data.src;
				}

				console.log(res)
				this.$message({
					showClose: true,
					message: '上传成功',
					type: 'success'
				});
			},
			resetForm(formName) {
				this.$refs[formName].resetFields();
			}
		}
	}
</script>

<style>
	.studioadd_box {
		padding: 0px 20px;
		width: 100%;
		height: 100%;
		box-sizing: border-box;
	}

	.studioadd_boxs {
		width: 100%;
		height: 87vh;
		overflow-y: scroll;
		box-sizing: border-box;
		padding: 20px 20px;
		background-color: #fff;
	}

	.studioadd_li {
		display: inline-block;
		width: 40%;
		vertical-align: middle;
	}

	.studioadd_boxs .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.studioadd_boxs .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.studioadd_boxs .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 218px;
		height: 170px;
		line-height: 170px;
		text-align: center;
	}

	.studioadd_boxs .avatar {
		width: 218px;
		height: 170px;
		display: block;
	}

	.el-tag+.el-tag {
		margin-left: 10px;
	}

	.button-new-tag {
		margin-left: 10px;
		height: 32px;
		line-height: 30px;
		padding-top: 0;
		padding-bottom: 0;
	}

	.input-new-tag {
		width: 90px;
		margin-left: 10px;
		vertical-align: bottom;
	}

	.studioadd_head {
		font-size: 16px;
		margin-bottom: 26px;
		margin-left: 10px;
	}

	.studioimg .avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.studioimg .avatar-uploader .el-upload:hover {
		border-color: #409EFF;
	}

	.studioimg .avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px;
		text-align: center;
	}

	.studioimg .avatar {
		width: 100px;
		height: 100px;
		display: block;
	}

	.studio_logo {
		width: 80px;
		height: 80px;
		vertical-align: bottom;
		margin-right: 10px;
	}
</style>
